import { useNextStepInfo } from './useNextStepInfo';
import { getGridViewOptionIdBySection } from './utils';
import { SimilarCompanies } from './components/SimilarCompanies';
import type { GridViewOptions } from '@/pages/CompanyReport/constants/constants';

export type NextStepSections =
  | 'valuation'
  | 'future'
  | 'past'
  | 'health'
  | 'dividend';

interface Props {
  section: NextStepSections;
  title: string;
}

interface BaseNextStepProps extends Props {
  gridViewOptionId: GridViewOptions;
}

export const BaseNextStep = ({
  section,
  title,
  gridViewOptionId,
}: BaseNextStepProps) => {
  const {
    companies,
    gridRulesStatus,
    gridCompaniesStatus,
    market,
    industry,
    companyId,
  } = useNextStepInfo({
    gridViewOptionId,
    section,
  });

  const isLoading =
    gridRulesStatus === 'pending' || gridCompaniesStatus === 'pending';
  const isErrored =
    gridRulesStatus === 'error' || gridCompaniesStatus === 'error';

  return (
    <SimilarCompanies
      title={title}
      companies={companies}
      section={section}
      market={market}
      industry={industry}
      gridViewOptionId={gridViewOptionId}
      isLoading={isLoading}
      isErrored={isErrored}
      companyId={companyId}
    />
  );
};

export const NextStep = ({ section, title }: Props) => {
  const gridViewOptionId = getGridViewOptionIdBySection(section);

  if (!gridViewOptionId) {
    return null;
  }

  return (
    <BaseNextStep
      section={section}
      title={title}
      gridViewOptionId={gridViewOptionId}
    />
  );
};
